

export default {
  // Letter output format (admin only).
  letter_format: 'Letter format',
  format_pdf: 'PDF',
  format_word: 'Word',
  format_word_hint: 'The letter is handed over as an editable Word file.',
  format_word_html_hint: 'This template is built in the letter editor, not from a Word file: the text, values and tables all arrive, but the background image, the stamp position and the table borders differ from the PDF.',
  // Letters system — page titles + actions
  'letter-template-index': 'Letter Templates',
  'issued-letter-index': 'Issued Letters',
  issue: 'Issue',
  issue_letter: 'Issue Letter',
  select_claim: 'Select Claim',
  select_template: 'Select Template',
  letter_preview: 'Letter Preview',
  view_pdf: 'View PDF',
  download_pdf: 'Download PDF',
  remove_stamp: 'Remove Stamp',
  no_active_template: 'No active template is linked to this client',
  issued_for_owner: 'Owner',
  issued_for_driver: 'Driver',
  issued_for_both: 'Owner & Driver',
  use_single_text: 'Single Text Field',
  use_single_text_hint: 'Hides greeting, subject, body, closing and footer, and shows one free field with text formatting.',
  insert_field: 'Insert Field',
  insert_field_hint: 'Click inside the target field, then pick a field to insert it at the caret.',
  show_table: 'Show As Table',
  show_table_hint: 'When unchecked the data still prints, but without the table and its borders.',
  select_all: 'Select all',
  select_none: 'Clear all',
  save_all_tabs_hint: 'Saving covers every tab at once.',
  discount_rules_empty: 'No years added yet — with no year on record the discount is uncapped.',
  template_source: 'Template source',
  template_source_hint: 'Either build the letter with the form, or upload a ready Word file that gets filled in and converted to PDF when a letter is issued.',
  source_builder: 'Built-in form',
  source_docx: 'Word file',
  tab_word: 'Word file',
  docx_file: 'Template file (docx)',
  docx_hint: '.docx only, up to 10 MB. The file defines the whole letter — letterhead, footer, stamp and tables.',
  docx_save_first: 'Save the template first, then upload the Word file.',
  docx_remove: 'Remove file',
  docx_found: 'Fields that will be replaced',
  docx_found_none: 'No known field was found in the file.',
  docx_split: 'Fields that will NOT be replaced',
  docx_split_fix: 'Word split these internally and they could not be rejoined automatically — usually because a line or paragraph break falls inside the field itself. Delete the field in Word and paste it back in one go (copy-paste, not typing).',
  docx_unknown: 'Unknown fields, left in the letter as they are:',
  docx_tokens_reference: 'Available fields',
  docx_tokens_reference_hint: 'Click a field to copy it, then paste it into the Word file where you want it.',
  copy_token: 'Click to copy',
  token_copy_failed: 'Could not copy — copy the field manually.',
  docx_issue_hint: 'The layout comes from the Word file; these are the values that will be merged into it.',
  docx_missing_template: 'No Word file has been uploaded for this template, so no letter can be issued.',
  user_note_docx_hint: 'Word template: the note is inserted as plain text (line breaks kept) in the formatting of the paragraph it sits in.',
  tab_general: 'General',
  tab_content: 'Letter Text',
  tab_fields: 'Printed Fields',
  tab_discount: 'Discount',
  tab_images: 'Images',
  admin_only: 'Admins only',
  admin_only_hint: 'When checked this template is only offered to admin users when issuing a letter.',
  requires_approval: 'Requires approval',
  requires_approval_hint_template: 'When checked, issuing does not create the letter: an approval request is sent to the administration, and the user can download it once approved.',
  requires_approval_hint: 'This template requires approval: the request will be sent and no letter is created until it is approved.',
  request_approval: 'Send approval request',
  approve_letter: 'Approve letter',
  cancel_letter: 'Cancel letter',
  replicate_template: 'Duplicate template',
  header_hint: 'The letterhead prints before anything else on the letter (before the logo and the date). Leave it empty if not needed.',
  user_note_hint: 'Formatted free text, printed wherever the template inserted the "user notes" field. Nothing is printed when it is left empty.',
  download_failed: 'The file could not be downloaded.',
  view_letter: 'View letter',
  claimFinancials: {
    button: 'Add discount',
    title: 'Claim discount',
    base_amount: 'Base amount',
    discount: 'Discount percentage',
    after_discount: 'Amount after discount',
    paid: 'Paid amount',
    remaining: 'Remaining amount',
    hint: 'A percentage from 0 to 100. Leave blank to clear the discount.',
    saved: 'Discount saved',
    save_failed: 'Could not save the discount',
  },
  field_labels: 'Field labels',
  field_labels_hint: 'Leave blank to use the default label, or type a label specific to this template.',
  allow_discount: 'Allow Discount',
  allow_discount_hint: 'When unchecked the user cannot enter a discount while issuing the letter.',
  add_discount_rule: 'Add Year',
  footer_hint: 'Printed at the bottom of every page of the letter (in both modes).',
  format_painter: 'Format Painter',
  insert_table: 'Insert Table',
  table_rows: 'Rows',
  table_cols: 'Columns',
  table_add_row: 'Add Row',
  table_add_col: 'Add Column',
  table_del_row: 'Delete Row',
  table_del_col: 'Delete Column',
  table_width: 'Table width',
  table_width_full: 'Full page width',
  table_width_center: 'Centred',
  table_width_auto: 'Fit content',
  table_fill: 'Table background',
  table_fill_none: 'No colour',
  table_scope_cell: 'Cell',
  table_scope_row: 'Row',
  table_scope_col: 'Column',
  table_scope_table: 'Table',
  stamp_align: 'Stamp alignment',
  stamp_align_hint: 'The stamp prints directly above the footer; this only sets where it sits across the page.',
  stamp_align_auto: 'Automatic',
  stamp_align_right: 'Right',
  stamp_align_center: 'Centre',
  stamp_align_left: 'Left',
  pick_color: 'Pick Colour',
  insert_image: 'Insert Image',
  remove_background: 'Remove Background',
  remove_logo: 'Remove Logo',
  logo_hint: 'Printed at the top of the letter across the full page width, never scaled down. Prefer about 1400x300 px (transparent PNG).',
  background_hint: 'Becomes the background of the whole letter page. Prefer an A4 portrait image (about 1240x1754 px).',
  stamp_hint: 'Printed near the bottom of the letter. Prefer about 600x330 px (transparent PNG).',
  insert_link: 'Insert Link',
  link_url: 'URL',
  remove_link: 'Remove Link',
  discount_max_hint: 'Maximum discount for this year',
  discount_free_hint: 'No maximum discount for this claim year',
  q: '?',
  sar: 'ريال',
  false: 'Disabled',
  true: 'Enabled',
  progress: 'progress ...',
  id: '#',
  ar: 'العربية',
  en: 'English',
  login: 'Login',
  home: 'Home',
  mainScreenHome: 'Claims Details',
  carMainScreenHome: 'Claims Details',
  policyMainScreenHome: 'Policies Details',
  legalMainScreenHome: 'Cases Details',
  done: 'Done',
  logout: 'Logout',
  cancel: 'Cancel',
  yes: 'Yes',
  no: 'No',
  enabled: 'Enabled',
  disabled: 'Disabled',
  save: 'Save',
  change: 'Change',
  options: 'options',
  create: 'create',
  store: 'Create',
  update: 'Update',
  upload: 'Upload',
  download: 'Download',
  download_template: 'Download Template',
  control: 'control',
  none: 'None',
  na: 'Na',
  export: 'Export',
  close: 'Close',
  edit: 'Edit',
  add: 'Add',
  register: 'Register',
  print: 'Print',
  today: 'Today',
  day: 'Day',
  date: 'Date',
  now: 'Now',
  am: 'AM',
  pm: 'PM',
  error: 'Error !!',
  search: 'Search',
  the_search: 'Search',
  calculator: 'Calculator',
  mortgage: 'Mortgage',
  personalProgram: 'Personal Program',
  propertyProgram: 'Property Program',
  flexibleProgram: 'Flexible Program',
  year: 'Year',
  showDetails: 'Show Details',
  Details: 'Details ',
  information: 'Information ',
  the_information: 'The Information ',
  setting: 'Setting',
  month: 'Month',
  subs: 'Status Fields',
  by_accident: 'Search by Accident Number',
  by_id: 'Search by Identity Number',
  by_legal_id: 'Identity / C.R Number',
  by_case: 'Case Number',
  by_claim: 'Claim Number',
  by_policy: 'Policy Number',
  by_client: 'Client',
  by_serial_number: 'Serial Number',
  by_consumer_work: 'Injered Work',
  by_plate: 'Plate',
  non_defined: 'Un-Defined',
  greg_letter: ' AD',
  hijri_letter: ' AH',
  import: 'Import',
  teleExcelImportDataEntry: 'Data Entry Excel File',
  teleExcelImportUpdate: 'Data Entry Update Excel File',
  teleExcelImportDeactivate: 'Data Entry Deactivate Excel File',
  ImportExcelUpdateNumber: 'Data Update',
  file_start_date: 'File Date',
  required: 'Not Exist!!!',
  unique: 'Duplicate!!!',
  persons_in_party_vehicle:'Persons in vehicle ',
  add_consumer:'Add injered',
  add_accident:'Add accident',
  add_claim:'Add claim',
  entry_actions:'Data Entry Actions',
  add_party_person:'Add person',
  add_party:'Add party',
  add_party_status:'Add claim status',
  add_claim_status:'Add claim status',
  add_car_claim_status:'Add Action',
  status_date_view:'Status Created at',
  is_consumer_view:'injered Belong to this Party',
  is_consumer_driver_view:'injered is the driver',
  plate_id:'Plate ID',
  attach_document:'Documents',
  car_cashier_screen: 'Collector Dashboard',
  car_claim_type1:'Full Insurance',
  car_claim_type2:'Third party insurance',
  car_claim_type3:'Unspecified',
  policy_already_exists: 'This policy number already exists',
  save_with_duplicate: 'Save despite duplicate',
  import_with_duplicate: 'Import despite duplicate',
  contracts_count: 'Contracts count',
  identity_claims: 'Identity claims',
  directed_claims: 'Directed claims',
  directed_to_me: 'Directed to me',
  directed_by_me: 'Directed by me',
  direct_claims: 'Direct claims',
  action_done: 'Action done',
  waiting_action: 'Waiting for action',
  browse_as_supervisor: 'Browse as supervisor',
  browse_as_collector: 'Browse as collector',
  back_as_collector: 'Back as collector',
  claim_status_assign_type:'Action Assign Type',
  assign_type1:'Private Assign',
  assign_type2:'Public Assign',
  parties_numbers:{
    1:  'First',
    2:  'Second',
    3:  'Third',
    4:  'Fourth',
    5:  'Fifth',
    6:  'Sixth',
    7:  'Seventh',
    8:  'Eighth',
    9:  'Ninth',
    10: 'Tenth',
  },
  show_assistance: 'View Assistance',
  edit_assistance: 'Edit Assistance',
  assistance_replies: 'Replies',
  add_reply: 'Add Reply',
  add_assistance: 'Ask Supervisor',
  close_assistance: 'Close Assistance',
  closed_assistances: 'Closed Assistance',
  all_assistances: 'All Assistance',
  updated_at: 'Updated At',
  created_at: 'Created At',
  or: 'OR',
  delete_actions: 'Delete Selected',
  assign_clients_for_user: 'Assign Clients For {name} ({count} Clients)',
  assign_clients_with_count: 'Assign Clients ({count} Clients)',
  assign_clients: 'Assign Clients',
  assign_client: 'Assign Client',
  unassign_client: 'Unassign Client',
  assign_tele_clients_for_user: 'Assign Tele Clients For {name} ({count} Clients)',
  assign_tele_clients_with_count: 'Assign Tele Clients ({count} Clients)',
  assign_tele_clients: 'Assign Tele Clients',
  assign_tele_client: 'Assign Tele Client',
  unassign_tele_client: 'Unassign Tele Client',
  tele_report1_tele_claim_status_row_date: 'Contact Date',
  tele_report1_tele_claim_status_row_notes: 'Notes',
  tele_report1_tele_claim_status_tele_client: 'Contact Result',
  tele_report1_tele_claim_status_field_row: 'Potential Payment Amount',
  tele_report1_amount_after_discount: 'Payment Amount After Discount',
  tele_report1_installments: 'Installments',
  tele_report1_mobile: 'Contact Number',
  tele_report1_contract_id: 'Contract ID',
  show_identity_claims: 'View Identity Claims',
  contract_count: 'Contracts Count',
  tele_assigned_to: 'Assigned To',
  search_claims: 'Search Policies from Excel',
  clear_search_claims: 'Cancel Policies Search',
  policy_count_found: 'Policies: <b>{0}</b>',
  tele_search_claims: 'Search by Excel',
  tele_search_count_found: 'Entries: <b>{0}</b>',
  tele_clear_search_claims: 'Cancel Search',
  mobile_or_mobile2_required: 'Mobile or Mobile2 field required',
  identity_or_client_account_or_contract_id_required: 'Identity or Client Account or Contract ID field required',
  last_installment_date: 'Last Installment Date',
  entry_required_claims: 'Claims Required for Entry',
};
